import { render } from "./FarmListItemEditTroops.vue?vue&type=template&id=18b29db0"
import script from "./FarmListItemEditTroops.vue?vue&type=script&lang=js"
export * from "./FarmListItemEditTroops.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/area/windowOverlay/FarmListItemEditTroops.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18b29db0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18b29db0', __exports__)) {
    api.reload('18b29db0', __exports__)
  }
  
  module.hot.accept("./FarmListItemEditTroops.vue?vue&type=template&id=18b29db0", () => {
    api.rerender('18b29db0', render)
  })

}


export default __exports__